import { createSlice } from "@reduxjs/toolkit";

const contantsSlice=createSlice({

name:'constants',
initialState:{

weburl:'https://hrbachatbazar.com/softwareapis/public/images/'
//weburl:'https://gadgetsworld.click/softwareapis/public/images/'

}



})

export default contantsSlice.reducer